<template>
  <div id="app">
    <Navbar/>
    <div class="container-fluid m-0 p-0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import Vue from 'vue'
import loading from "vuejs-loading-screen";
window.EventBus = new Vue();
Vue.use(loading, {
  bg: "rgba(0,0,0,0.5);",
  slot: `
    <div class="px-5 py-3 bg-gray-800 rounded">
      <h3 class="text-4xl color-loading"><i class="fas fa-circle-notch fa-spin" style="font-size: 50pt"></i></h3>
    </div>
  `,
});
export default {
  components: {
    Navbar
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.color-loading {
  color: #ee8813;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>